/* eslint-disable */
import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import {Toolbar, Theme} from "@material-ui/core";
import cn from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      paddingTop: theme.spacing(2)
    }
  });

export type ReportToolbarProps = {
  className?: string;
  exportMode?: boolean;
};

type Props = ReportToolbarProps & WithStyles<typeof styles>;

class ReportToolbar extends React.Component<Props> {
  render() {
    const { classes, className, children, exportMode } = this.props;
    return (
      <Toolbar style={exportMode ? {display: 'none'} : undefined} className={cn(classes.root, className)}>{children}</Toolbar>
    );
  }
}

export default withStyles(styles)(ReportToolbar);
